import { Component, Input } from '@angular/core';

@Component({
	selector: 'form-error',
	templateUrl: './form-error.component.html',
	styleUrls: ['./form-error.component.scss']
})
export class FormError
{
	@Input()
	message: string;

	constructor() {}
}
